import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UnitDetailsModal = ({ unit, onClose, onEdit }) => {
  if (!unit) return null;
  const teachingGroupCodes = (unit.teachingGroupMembers || []).map(member => member.code).filter(Boolean);
  const detail = [
    ['Programme', unit.program?.name || 'Not assigned'],
    ['Department', unit.program?.department?.name || 'Not assigned'],
    ['Programme level', unit.programLevel ? `Level ${unit.programLevel}` : 'Not configured'],
    ['Module', unit.module || 'Not configured'],
    ['Classification', unit.unitType || 'Core'],
    ['Credit hours', unit.creditHours ?? 'Not configured'],
    ['Hours per week', unit.hoursPerWeek ?? 'Not configured'],
    ['Session length', unit.sessionLengthMinutes ? `${unit.sessionLengthMinutes} minutes` : 'Not configured'],
    ['Required room', unit.roomType || 'Standard Classroom'],
    ['Units taught together', teachingGroupCodes.length > 1 ? teachingGroupCodes.join(' + ') : 'Individual delivery'],
  ];
  return <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/55 p-4 backdrop-blur-sm">
    <div className="flex max-h-[90vh] w-full max-w-3xl flex-col overflow-hidden rounded-xl border bg-card shadow-2xl">
      <div className="flex items-start justify-between border-b p-6"><div><p className="font-mono text-sm text-primary">{unit.code}</p><h3 className="text-2xl font-bold">{unit.name}</h3></div><button onClick={onClose}><Icon name="X" /></button></div>
      <div className="overflow-y-auto p-6">
        <div className="mb-6 grid gap-4 sm:grid-cols-3">
          <div className="rounded-lg border bg-blue-50 p-4"><p className="text-sm text-muted-foreground">Total enrolled students</p><p className="mt-1 text-3xl font-bold text-blue-700">{Number(unit.enrolled || 0).toLocaleString()}</p></div>
          <div className="rounded-lg border p-4"><p className="text-sm text-muted-foreground">Unit status</p><p className="mt-1 font-semibold">{unit.isActive === false ? 'Inactive' : 'Active'}</p></div>
          <div className="rounded-lg border p-4"><p className="text-sm text-muted-foreground">Trainer</p><p className="mt-1 font-semibold">{unit.trainerAssignment?.trainer?.fullName || (String(unit.trainerAssignment?.status).toLowerCase() === 'pending' ? 'Pending HOD approval' : 'Unassigned')}</p></div>
        </div>
        <dl className="grid gap-x-8 gap-y-4 sm:grid-cols-2">{detail.map(([label,value]) => <div key={label} className="border-b pb-3"><dt className="text-xs uppercase tracking-wide text-muted-foreground">{label}</dt><dd className="mt-1 font-medium">{value}</dd></div>)}</dl>
      </div>
      <div className="flex justify-end gap-3 border-t p-5"><Button variant="outline" onClick={onClose}>Close</Button><Button onClick={() => onEdit(unit)}><Icon name="Edit" size={16} className="mr-2" />Edit Unit</Button></div>
    </div>
  </div>;
};

export default UnitDetailsModal;
